module.exports = __webpack_public_path__ + "static/media/no-address-warning.403d5f09.svg";